import { FC } from 'react';

import { IconProps } from '../../types/icon.types';

export const Information: FC<IconProps> = ({ width = 18, height = 18, fill = '#0065FF', className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9ZM8.99999 4.25C8.53055 4.25 8.14999 4.63056 8.14999 5.1C8.14999 5.56944 8.53055 5.95 8.99999 5.95C9.46944 5.95 9.84999 5.56944 9.84999 5.1C9.84999 4.63056 9.46944 4.25 8.99999 4.25ZM11.1 13C11.1 13.4142 10.7642 13.75 10.35 13.75H10.3C9.16781 13.75 8.24999 12.8322 8.24999 11.7V7.95001C8.24999 7.5358 8.58578 7.20001 8.99999 7.20001C9.41421 7.20001 9.74999 7.5358 9.74999 7.95001V11.7C9.74999 12.0038 9.99624 12.25 10.3 12.25H10.35C10.7642 12.25 11.1 12.5858 11.1 13Z"
        fill={fill}
      />
    </svg>
  );
};
